export const lightTheme = {
  primary: '#3498db',
  primaryLight: '#5dade2',
  primaryDark: '#2980b9',
  success: '#2ecc71',
  warning: '#f1c40f',
  error: '#e74c3c',
  info: '#3498db',
  background: '#f8f9fa',
  surface: '#ffffff',
  surfaceHover: '#f8f9fa',
  text: '#2c3e50',
  textSecondary: '#7f8c8d',
  border: '#e0e0e0',
  hover: '#f5f6fa',
  tableHeader: '#f8f9fa',
  shadow: '0 2px 4px rgba(0,0,0,0.1)',
  shadowHover: '0 4px 8px rgba(0,0,0,0.15)',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  gradientPrimary: 'linear-gradient(135deg, #3498db, #2980b9)',
  gradientSuccess: 'linear-gradient(135deg, #2ecc71, #27ae60)',
  gradientError: 'linear-gradient(135deg, #e74c3c, #c0392b)',
};

export const darkTheme = {
  primary: '#4a9eff',
  primaryLight: '#5dade2',
  primaryDark: '#2980b9',
  success: '#2ecc71',
  warning: '#f1c40f',
  error: '#e74c3c',
  info: '#3498db',
  background: '#1a1b1e',
  surface: '#25262b',
  surfaceHover: '#2c2d31',
  text: '#e0e0e0',
  textSecondary: '#a0a0a0',
  border: '#404040',
  hover: '#2c2d31',
  tableHeader: '#2c2d31',
  shadow: '0 2px 4px rgba(0,0,0,0.2)',
  shadowHover: '0 4px 8px rgba(0,0,0,0.3)',
  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
  gradientPrimary: 'linear-gradient(135deg, #4a9eff, #2980b9)',
  gradientSuccess: 'linear-gradient(135deg, #2ecc71, #27ae60)',
  gradientError: 'linear-gradient(135deg, #e74c3c, #c0392b)',
};
